/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { StakingRewardsWithPlatformToken } from "../StakingRewardsWithPlatformToken";

export class StakingRewardsWithPlatformToken__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _nexus: string,
    _stakingToken: string,
    _rewardsToken: string,
    _platformToken: string,
    _rewardsDistributor: string,
    overrides?: Overrides
  ): Promise<StakingRewardsWithPlatformToken> {
    return super.deploy(
      _nexus,
      _stakingToken,
      _rewardsToken,
      _platformToken,
      _rewardsDistributor,
      overrides || {}
    ) as Promise<StakingRewardsWithPlatformToken>;
  }
  getDeployTransaction(
    _nexus: string,
    _stakingToken: string,
    _rewardsToken: string,
    _platformToken: string,
    _rewardsDistributor: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _nexus,
      _stakingToken,
      _rewardsToken,
      _platformToken,
      _rewardsDistributor,
      overrides || {}
    );
  }
  attach(address: string): StakingRewardsWithPlatformToken {
    return super.attach(address) as StakingRewardsWithPlatformToken;
  }
  connect(signer: Signer): StakingRewardsWithPlatformToken__factory {
    return super.connect(signer) as StakingRewardsWithPlatformToken__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StakingRewardsWithPlatformToken {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as StakingRewardsWithPlatformToken;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_rewardsToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_platformToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "platformReward",
        type: "uint256",
      },
    ],
    name: "RewardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "platformReward",
        type: "uint256",
      },
    ],
    name: "RewardPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    constant: true,
    inputs: [],
    name: "DURATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "claimReward",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "claimRewardOnly",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [],
    name: "exit",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "getRewardToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_reward",
        type: "uint256",
      },
    ],
    name: "notifyRewardAmount",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "platformRewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "platformRewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "platformRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "platformToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "platformTokenVendor",
    outputs: [
      {
        internalType: "contract PlatformTokenVendor",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardsDistributor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "rewardsToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
    ],
    name: "setRewardsDistribution",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userPlatformRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userRewardPerTokenPaid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
